import { createI18n } from 'vue-i18n'
import es from './es.json'
import ca from './ca.json'
import en from './en.json'

export const i18n = createI18n({
  legacy: false,      // Composition API mode
  locale: 'es',
  fallbackLocale: 'es',
  messages: { es, ca, en },
  // Suprime el aviso de "Missing translation" para locales vacíos (ca, en)
  missing: () => undefined,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
})
